App.prototype.addDropshippingProduct = function () {
    const newUrl = new URL(window.location.href);
    //newUrl.searchParams.delete('payload');
    history.replaceState({}, null, newUrl.origin + '/basket');
    setTimeout(() => {
        $('.add-product-variation-to-cart-form').find('button[type=submit]').first().trigger('click');
    }, 500);
};
